const app = require('app'),
    getLanguage = require('./getLanguage'),
    setLanguage = require('./setLanguage');

module.exports = function (language) {
    let currentLanguage = getLanguage('language');
    if (language !== currentLanguage) {
        setLanguage(language);
        window.location.reload(true);
    }
};
